import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'spw-header-lang-item',
  styleUrl: 'spw-header-lang-item.scss',
  shadow: true,
})
export class SpwHeaderLangItem {
  @Prop({ reflect: true }) active: boolean = false;

  render() {
    return (
      <Host>
        <div class={{ 'spw-header-lang-item': true, 'spw-header-lang-item--active': this.active }}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
